import {authRequest} from './index.js'

export async function get_invoice_setting(){
  let data
  await authRequest.get('/invoice_setting')
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data || error.message}
  })
  return data
}

export async function update_invoice_setting(invoice_setting){
  let data = ''
  await authRequest.patch(
    '/invoice_setting',
    { invoice_setting }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data || error.message}
  })
  return data
}
